import { render, staticRenderFns } from "./ElipsisButton.vue?vue&type=template&id=338a7e0e&"
import script from "./ElipsisButton.vue?vue&type=script&lang=js&"
export * from "./ElipsisButton.vue?vue&type=script&lang=js&"
import style0 from "./ElipsisButton.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports